export const APP_URLS = {
    PRIVACY: 'https://apphitminchan.com/privacy',
    TERMS: 'https://apphitminchan.com/terms',
    SUPPORT: 'info@apphitminchan.com',
    GROWSTATS: 'https://growstats.io/',
};
